import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    oneTimeTasks: [],
    oneTimeTask: {},
    oneTimeTasksById: []
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindTasks: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "oneTimeTasks",
        db
          .collection("oneTimeTasks")
          .where("equipmentProfile", "==", db.doc(`equipments/${id}`))
          .where("disabled", "==", false)
          .orderBy("dateCreated", "desc")
      );
    }),
    bindATask: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "oneTimeTask",
        db.collection("oneTimeTasks").doc(id)
      );
    }),
    bindTasksById: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "oneTimeTasksById",
        db
          .collection("oneTimeTasks")
          .where("recurringTaskId", "==", id)
          .where("disabled", "==", false)
          .orderBy("dateCreated", "desc")
      );
    })
  },
  getters: {}
};
